export const toBrCurrency = (x) => {
	const fixedValue = x ? x.toFixed(2) : 0;
	const regex = fixedValue
		.toString()
		.replace('.', ',')
		.replace(/(\d)(?=(\d{3})+\,)/g, '$1.'); //eslint-disable-line
	return regex.split(',')[1]
		? regex.split(',')[1].length === 1
			? regex + '0'
			: regex
		: regex;
};


export function handleFieldChangeNumberOnly(value) {
	const replacedValue = value.replace(/[^0-9]/g, '')
	return replacedValue;
}